import {sortBy,cloneDeep} from 'lodash'
import {loader, navigateTo, getImageUrl, onError, message, logout, errorHandler} from '@/libs/helper'
import {getRegisteredList, removeAuthorListing} from '@/libs/api/api'
import RegisteredList from '@/components/component/RegisteredList/RegisteredList.vue'
import constants from '@/libs/constant/constants'
import pageRoutes from '@/libs/constant/pageRoutes'
import { mapGetters }  from 'vuex';
import permissions from '@/libs/constant/permissions'
export default{
    name: 'MetaListing',
    components:{
        RegisteredList
    },
    beforeMount(){
       this.fetchRegisteredList()
    },
    computed:{
        ...mapGetters(['hasPermission'])
    },
    data(){
        return {
            authors: [],
            publications: [],
            publishers: [],
            navigateTo,
            getImageUrl,
            onError,
            isFetching: false,
            permissions: permissions
        }
    },
    methods: {
        /**
         * route to the following route
         */
        routeTo(module){
            switch (module){
                case constants.AUTHOR.key:
                    this.$router.push({name: 'AddAuthor'})
                break
                case constants.PUBLISHER.key:
                    this.$router.push({name: 'AddPublisher'})
                break
                case constants.PUBLICATION.key:
                    this.$router.push({name: 'AddPublication'})
                break
            }
        },
        /**
         * update list
         */
        updateList(){
            this.authors = this.$store.getters.getRegisteredAuthor || []
            this.publishers = this.$store.getters.getRegisteredPublisher || []
            this.publications = this.$store.getters.getRegisteredPublication || []
        },
        /**
         * fetch registeserd card list
         */
        fetchRegisteredList () {
            this.isFetching = true
            getRegisteredList({})
            .then((response)=> {
                this.authors = sortBy(response.items.AUTHOR || [], 'name')
                this.publications = sortBy(response.items.PUBLICATION || [], 'name')
                this.publishers = sortBy(response.items.PUBLISHER || [], 'name')
                this.$store.dispatch('setRegisteredAuthor', sortBy(this.authors, 'name'))
                this.$store.dispatch('setRegisteredPublisher', sortBy(this.publishers, 'name'))
                this.$store.dispatch('setRegisteredPublication', sortBy(this.publications, 'name'))
                this.isFetching = false
            }).catch((error)=> {
                this.isFetching = false
                return error
            })
        },

        /**
         * switch menu
         */
        changeMenu (menu) {
            this.activeMenu = menu
        },

        /**
         * route to settings button of info- portal
         */
        routeToSettingsButton (type, meta) {
            this.$router.push({name: `${type}-settings`, params:{id: meta._id}}).catch(() => {})
        },

        /**
         * get the heading pf remove meta
         */
        getRemovePopupHeading(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Remove Author listing'
                case constants.PUBLISHER.key:
                    return 'Remove Publisher listing'
                case constants.PUBLICATION.key:
                    return 'Remove publication listing'
            }
        },

        /**
         * open popup for removing meta
         */
        openRemovePopup(module, item){
            const mainTitle = window.i18next.t(this.getRemovePopupHeading(module));
            const nameTitle = item.name;
            const popUpfor = constants[module].value
            // html for popup
            const html =
                `<div class="remove-list-warning-container">
                    <div class="popup-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove a listing, you can no longer make any changes to it. Also, another User can take over the management of the listing')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text">
                        ${window.i18next.t('Are you sure you would like to remove this listing, it can not be undone')}?
                    </div>
                    <div class="follow-checkbox">
                        <input class="checkbox" id="checkbox" type="checkbox" checked/>
                        <span class="checkbox-label">${window.i18next.t(`Keep following this ${popUpfor}`)} </span>
                    </div>
                </div>`
            // confirmation box
            this.$confirm(`${html}`, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: window.i18next.t('Remove'),
                cancelButtonText: window.i18next.t('Cancel'),
                showClose: false,
                closeOnClickModal: false,
                customClass: 'confirmBox'
            }).then(() => {
                // api all
                this.removeListingAPI(module, item)
            }).catch((error) => {
                console.error('--', error)
            })
        },

        /**
         * method to remove the listing
         */
        removeListingAPI(module, item){
            loader(this, true)
            let checkbox = document.getElementById('checkbox').checked

            let body = {
                following: checkbox,
                id: item._id,
                type: module
            }
            // api call
            removeAuthorListing(body)
                .then((response)=>{
                    loader(this, false)
                    this.updateStoreListing(module, body, checkbox)
                    message(this, constants.messageType.SUCCESS, (response.message))
                    document.getElementById('checkbox').checked = true
                    this.updateList()
                })
                .catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        },
        /**
         * to update the store listings 
         */
        updateStoreListing(module, body, checkbox){
            switch (module){
                case constants.AUTHOR.key:
                    this.$store.dispatch('removeRegisteredAuthor', {_id: body.id})
                    if(!checkbox){
                        let authorsFollowings = cloneDeep(this.$store.getters.getUserFollowings.author || [])
                        authorsFollowings = authorsFollowings.filter(af => af._id !== body.id)
                        this.$store.dispatch('updateUserFollowingsAuthorToStore', authorsFollowings)
                    }
                    break
                case constants.PUBLISHER.key:
                    this.$store.dispatch('removeRegisteredPublisher', {_id: body.id})
                    if(!checkbox){
                        let publisherFollowings = cloneDeep(this.$store.getters.getUserFollowings.publisher || [])
                        publisherFollowings = publisherFollowings.filter(af => af._id !== body.id)
                        this.$store.dispatch('updateUserFollowingsPublisherToStore', publisherFollowings)
                    }
                    break
                case constants.PUBLICATION.key:
                    this.$store.dispatch('removeRegisteredPublication', {_id: body.id})
                    if(!checkbox){
                        let publicationFollowings = cloneDeep(this.$store.getters.getUserFollowings.publication || [])
                        publicationFollowings = publicationFollowings.filter(af => af._id !== body.id)
                        this.$store.dispatch('updateUserFollowingsPublicationToStore', publicationFollowings)
                    }
                    break
            }
        },

        /**
         * route to overview page of A/P/P
         */
        routeToOverViewPage (type, meta) {
            let routeName = ``
            switch (type) {
                case constants.AUTHOR.key:
                    routeName = pageRoutes.authorOverview
                break
                case constants.PUBLICATION.key:
                    routeName = pageRoutes.publicationOverview
                break
                case constants.PUBLISHER.key:
                    routeName = pageRoutes.publisherOverview
                break
            }
            this.$router.push({name: routeName, params: {id: meta._id}}).catch(() => {})
        }
    }
}